import axiosService from 'services/axios.service';

const API_URL = process.env.REACT_APP_URL_API;

const BASE_API_URL = `${API_URL}/v1/admin`;

export const getUserSubscriptionTransaction = async (userId: string): Promise<any> => {
    const response = await axiosService.get(`${BASE_API_URL}/subscription-transactions/${userId}`);

    return response?.data?.data;
};

export const creatSubscriptionTransaction = async (body: any): Promise<any> => {
    const response = await axiosService.post(`${BASE_API_URL}/subscription-transactions`, body);
    return response?.data?.data;
};

export const getPackageActive = async (): Promise<any> => {
    const response = await axiosService.get(`${BASE_API_URL}/subscription-packages/active`);
    return response?.data?.data;
};

export const handleCancelSubscription = async (userId: string): Promise<any> => {
    const response = await axiosService.get(`${BASE_API_URL}/users/cancel-subscription/${userId}`);
    return response?.data?.data;
};
